/**
 * Bytem recommendation runtime deps (ported from oldTheme img_data.js).
 * Requires jQuery and jQuery.cookie.
 */
(function () {
  window.theme = window.theme || {};

  var screenWidth = $(window).width();
  window.screenWidth = screenWidth;

  function set_cookie_id() {
    var cookie_id = $.cookie('as_shopify_id');
    if (cookie_id) return cookie_id;
    var as_shopify_id = new Date().getTime() + '' + Math.floor(Math.random() * 100000);
    $.cookie('as_shopify_id', as_shopify_id, { expires: 365, path: '/' });
    return as_shopify_id;
  }
  window.set_cookie_id = set_cookie_id;
  window.is_old_user = !!$.cookie('as_shopify_id');
  set_cookie_id();

  function filter_handle(str) {
    if (!str) return '';
    return String(str)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }
  window.filter_handle = filter_handle;

  function AjaxApi(url, data, method) {
    data = data || {};
    data.shopId = String(theme.shopId || '');
    var BASE_URL = 'https://sw.ahaselected.com';
    return $.ajax({
      method: method || 'GET',
      url: BASE_URL + '/aha-web' + url,
      contentType: 'application/json',
      data: method ? JSON.stringify(data) : data,
    }).then(function (response) {
      return response;
    });
  }
  window.AjaxApi = AjaxApi;

  function getProductGridSku(product) {
    var sortedOptionNames = product.sortedOptionNames || [];
    var skuVOList = product.skuVOList || [];
    var colorIndex = sortedOptionNames.findIndex(function (option) {
      return option.toLowerCase() === 'color';
    });
    if (colorIndex === -1) return [];
    var skus = skuVOList.map(function (sku) {
      return sku['option' + (colorIndex + 1)];
    });
    return [...new Set(skus)].map(function (sku) {
      return {
        name: sku,
        color_name: filter_handle(sku),
        colorIndex: colorIndex,
      };
    });
  }

  function productGridSku(opts) {
    var pClass = opts.pClass;
    var products = opts.products || [];
    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      var skuColorData = product.skuColorData;
      var spuId = product.spuId;
      var skuVOList = product.skuVOList;
      var skus = getProductGridSku(product);
      var _currentProduct = $(pClass + ' .request-list-item[data-spu="' + spuId + '"] .ajax-product-color');
      if (_currentProduct.find('.apc-lists').length > 0) continue;
      var start_num = 5;
      if (skuColorData) {
        try {
          var _skuColorData = JSON.parse(skuColorData);
          var styleTag = $('<style>');
          var colorStyle = '';
          for (var c = 0; c < _skuColorData.length; c++) {
            var _color = _skuColorData[c];
            colorStyle +=
              '.apc-list.swt-' +
              spuId +
              '-' +
              filter_handle(_color.colorName) +
              ' { background: url(' +
              _color.imageUrl +
              ') no-repeat 50% 50%/cover !important } \n';
          }
          styleTag.text(colorStyle);
          _currentProduct.append(styleTag);
        } catch (e) {}
      }
      var colorHtml = '<ul class="apc-lists">';
      var _skus = skus.slice(0, start_num);
      for (var s = 0; s < _skus.length; s++) {
        var sku = _skus[s];
        var rel =
          (skuVOList || []).find(function (list) {
            return list['option' + (sku.colorIndex + 1)] == sku.name;
          })?.image || '';
        colorHtml +=
          '<li rel="' +
          rel +
          '" class="apc-list swt-' +
          spuId +
          '-' +
          sku.color_name +
          ' swt' +
          sku.color_name +
          '" style="background-color: ' +
          sku.color_name +
          ';"></li>';
      }
      if (skus.length > start_num) {
        colorHtml += '<li class="apc-list-num">+' + (skus.length - start_num) + '</li>';
      }
      colorHtml += '</ul>';
      _currentProduct.append(colorHtml);
    }
  }
  window.productGridSku = productGridSku;

  function throttle(fn, delay) {
    var valid = true;
    return function () {
      var _this = this;
      var _arguments = arguments;
      if (!valid) return false;
      valid = false;
      setTimeout(function () {
        fn.apply(_this, _arguments);
        valid = true;
      }, delay);
    };
  }
  window.throttle = throttle;
})();
